/**
 * Created by olga on 10.07.2025
 */

const RenovationWindow = CleverappsWindow.extend({
    onWindowLoaded: function () {
        this.starsAmount = cleverapps.meta.getSelectedLocation().getMigratedStars();
        this._super({
            title: Messages.get("RenovationWindow.title"),
            name: "renovationwindow",
            content: this.getContent(),
            button: {
                width: cleverapps.styles.RenovationWindow.button.width,
                height: cleverapps.styles.RenovationWindow.button.height,
                text: Messages.get("RenovationWindow.play"),
                onPressed: function () {
                    this.close();
                }.bind(this)
            }
        });
    },

    getPerson: function () {
        return {
            role: "hero",
            emotion: "happy"
        };
    },

    getContent: function () {
        const styles = cleverapps.styles.RenovationWindow;
        const image = new cc.Sprite(bundles.renovation_window.frames.renovation_window_png);
        const elements = [image, this.getText()];

        return new cleverapps.Layout(elements, {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin
        });
    },

    getText: function () {
        const styles = cleverapps.styles.RenovationWindow;
        const title = cleverapps.UI.generateOnlyText(Messages.get("RenovationWindow.text.title"), cleverapps.styles.FONTS.RENOVATION_WINDOW_TEXT);
        title.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        title.setDimensions(styles.text.width, 0);
        title.fitTo(undefined, styles.text.height);

        const items = [];

        for (let i = 0; i < 3; i++) {
            items.push(this.getTextItem(i));
        }

        const itemsLayout = new cleverapps.Layout(items, {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin
        });

        return new cleverapps.Layout([title, itemsLayout], {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin
        });
    },

    getTextItem: function (item) {
        const text = Messages.get(`RenovationWindow.text.item${item}`, {
            stars: `${this.starsAmount} **`
        });
        const layout = new TextWithIcon(`^^ ${text}`, {
            font: cleverapps.styles.FONTS.RENOVATION_WINDOW_TEXT,
            icons: {
                "**": bundles.reward_icons.frames.simple_star_png,
                "^^": bundles.renovation_window.frames.check_mark_png
            }
        });
        layout.setAnchorPoint(0, 0.5);

        return layout;
    },

    onClose: function () {
        cleverapps.focusManager.display({
            focus: "RewardWindow",
            stack: true,
            action: (f) => {
                new RewardWindow({ metaStar: this.starsAmount });
                cleverapps.focusManager.onceNoWindowsListener = f;
            }
        });
        this._super();
    },

    listBundles: function () {
        return ["renovation_window"];
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    RENOVATION_WINDOW_TEXT: {
        size: 35,
        color: cleverapps.styles.COLORS.LIGHT_BROWN
    }
});

cleverapps.styles.RenovationWindow = {
    margin: 20,
    text: {
        width: 900,
        height: 400
    },

    button: {
        width: 300,
        height: 100
    }
};